import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../../components/Hero';
import TelecomLinkBoxRow from '../../components/TelecomLinkBoxRow';

export type IFT_016_2024Props = {};

const IFT_016_2024: React.FC<IFT_016_2024Props> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/telecom-header-planet.png'}
        heading={intl.formatMessage({
        id: "telecommunications",
        defaultMessage: "Telecommunications"
        })}
        subHeading='IFT-016-2024'
      />
      <TelecomLinkBoxRow />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-16">
        <div className="flex w-full flex-col items-start justify-center">
          <div className="flex flex-col w-full pt-0 md:pt-6 pb-10 md:pb-0 gap-10 pr-10 max-w-[950px]">
            <div className="">
              <h2 className='text-xl text-secondary font-bold mb-2'>
                IFT-016-2024
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "ift_016_2024_title",
                    defaultMessage: "Devices that make use of frequency bands of the radio spectrum within the range of 30 MHz to 3 GHz."
                  })
                }
              </p>
            </div>
            <div>
              <h2 className='text-xl text-secondary font-bold uppercase mb-2'>
                {
                  intl.formatMessage({
                    id: 'scope',
                    defaultMessage: "Scope:"
                  })
                }
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "ift_016_2024_scope",
                    defaultMessage: "It is applicable to all low-power radiocommunication devices, equipment, or products that can use frequency bands of the radio spectrum within the range of 30 MHz to 3 GHz."
                  })
                }
              </p>
            </div>
          </div>
          <div className="w-full mt-12 flex justify-center">
            <img className="max-w-md w-full" src="/img/ift-016-image.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
} 

export default IFT_016_2024;